import { useAuth } from "../../auth/AuthContext";

export function LoginButton() {
  const { login, isLoading, error } = useAuth();

  return (
    <div className="flex flex-col items-center gap-2">
      <button className="btn-primary" onClick={login} disabled={isLoading}>
        {isLoading ? "Signing in..." : "Sign in"}
      </button>
      {error && <p className="error-text">{error.message}</p>}
    </div>
  );
}
